import Casino from './casino';
import CasinoDetail from './category/detail';
export default Casino;
export {CasinoDetail};
